import React, { useEffect, useState } from 'react';
import './page.css';
import './table.css';
import { Box, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ReactECharts from 'echarts-for-react';
import { resolveDate } from '../../../../configs/helpers/utility';

const useStyles = makeStyles((theme) => ({
   graphsContainer: {
      width: '100%',
   },
}));

const PDFCSS = () => {
   const classes = useStyles();
   const [totalPoint, setTotalPoint] = useState();
   const [filtersData, setFiltersData] = useState();
   const [MultiChartData, setMultiChartData] = useState();
   const [MultiTable, setMultiTable] = useState();
   useEffect(() => {
      let report = localStorage.getItem('report');
      if (report) {
         let { totalPoint, filtersData, MultiChartData, MultiTable } =
            JSON.parse(report);
         setTotalPoint(totalPoint);
         setFiltersData(filtersData);
         setMultiChartData(MultiChartData);
         setMultiTable(MultiTable);
         window.print();
      }
      return () => {
         localStorage.removeItem('report');
      };
   }, []);
   const costFormat = (value) => {
      return value && new Intl.NumberFormat().format(value);
   };
   const getChartsOptionsDefault = () => {
      let option = {
         animation: false,
         animationDuration: 0,
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               // Use axis to trigger tooltip
               type: 'shadow', // 'shadow' as default; can also be 'line' or 'shadow'
            },
         },
         legend: {},
         grid: {
            top: '10%',
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true,
         },
         xAxis: {
            type: 'value',
         },
         yAxis: {
            type: 'category',
            data: null,
            axisLabel: {
               formatter: (value) => JSON.parse(value).shortName,
            },
         },
         series: [
            {
               color: '',
               stack: 'total',
               type: 'bar',
               data: null,
            },
            {
               color: '',
               stack: 'total',
               type: 'bar',
               data: null,
            },
         ],
      };
      return option;
   };
   const mapOptions = (data) => {
      let yAxisLabels = data.bankWallets.map((el) =>
         JSON.stringify({ shortName: el.shortNameTh, fullName: el.nameTh }),
      );
      let remainPoints = data.bankWallets.map((el) => el.remainPoints);
      let totalUsedPoints = data.bankWallets.map((el) => el.totalUsedPoints);
      let options = getChartsOptionsDefault();
      options.tooltip.formatter = (params) => {
         let html = `<div>${JSON.parse(params[0].name).fullName}</div>`;
         params.forEach((el, i) => {
            html += `<div>${el.marker} ${el.seriesName} ${costFormat(
               el.value,
            )}</div>`;
         });
         html += `<div>จำนวนคะแนน P ทั้งหมด ${costFormat(
            params[0].value + params[1].value,
         )}</div>`;
         return html;
      };
      options.yAxis.data = yAxisLabels;
      options.series[0].data = remainPoints;
      options.series[0].name = 'จำนวนคะแนน P คงเหลือ';
      options.series[0].color = '#67B0DA';
      options.series[1].data = totalUsedPoints;
      options.series[1].name = 'จำนวนคะแนน P ที่ใช้ไป';
      options.series[1].color = '#F383BB';
      return options;
   };
   return (
      <div className='book'>
         <div className='page' id='1'>
            <div className='subpage'>
               <div className='title'>แสดงคะแนนโครงการแบ่งตามสังกัด</div>
               <div className='sub-title'>สรุปการใช้คะแนน</div>
               <div className='content'>
                  ปี : {totalPoint && totalPoint.year}
                  <table className='normal'>
                     <tr>
                        <th>ประเภท</th>
                        <th>คะแนนทั้งหมด</th>
                        <th>ใช้ไป P</th>
                        <th>ใช้ไป GSB Way of Work</th>
                        <th>ใช้ไปหลักเกณฑ์</th>
                        <th>คงเหลือ</th>
                        <th>อัพเดทล่าสุดเมื่อ</th>
                     </tr>
                     {totalPoint && totalPoint.hrPoints && (
                        <tr>
                           <td>HR</td>
                           <td class='text-right'>
                              {costFormat(totalPoint.hrPoints.totalReceived)}
                           </td>
                           <td class='text-right'>
                              {costFormat(
                                 totalPoint.hrPoints.totalBankWalletUsed,
                              )}
                           </td>
                           <td class='text-right'>
                              {costFormat(
                                 totalPoint.hrPoints.totalEmployeeUsed,
                              )}
                           </td>
                           <td class='text-right'>
                              {costFormat(totalPoint.hrPoints.totalRuleUsed)}
                           </td>
                           <td class='text-right'>
                              {costFormat(
                                 totalPoint.hrPoints.totalRemainingPoints,
                              )}
                           </td>
                           <td>{totalPoint.hrPoints.updateTimeLabel}</td>
                        </tr>
                     )}
                  </table>
                  <table className='normal' style={{ marginTop: '10px' }}>
                     <tr>
                        <th>ประเภท</th>
                        <th>คะแนนทั้งหมด</th>
                        <th>ใช้ไป</th>
                        <th>คงเหลือ</th>
                        <th>อัพเดทล่าสุดเมื่อ</th>
                     </tr>
                     {totalPoint &&
                        totalPoint.allPoints &&
                        totalPoint.allPoints
                           .filter((item) =>
                              ['B', 'G', 'S'].includes(item.currency),
                           )
                           .sort((a, b) => {
                              const order = { B: 0, G: 1, S: 2 };
                              return order[a.currency] - order[b.currency];
                           })
                           .map((item, index) => {
                              const currencyTextMap = {
                                 G: 'with GOVERNANCE',
                                 S: 'through DIGITALIZATION',
                                 B: 'for SOCIETY',
                              };
                              const displayCurrency =
                                 currencyTextMap[item.currency];

                              return (
                                 <tr key={index}>
                                    <td>{displayCurrency}</td>
                                    <td class='text-right'>
                                       {costFormat(item.totalReceived)}
                                    </td>
                                    <td class='text-right'>
                                       {costFormat(item.totalRedeem)}
                                    </td>
                                    <td class='text-right'>
                                       {costFormat(item.totalRemainingPoints)}
                                    </td>
                                    <td>{item.updateTimeLabel}</td>
                                 </tr>
                              );
                           })}
                  </table>
               </div>
               <div className='sub-title'>ตัวกรอง</div>
               <div>
                  <div>
                     เริ่มต้น:{' '}
                     {(filtersData &&
                        resolveDate(filtersData.startDateString)) ||
                        '-'}
                  </div>
                  <div>
                     สิ้นสุด:{' '}
                     {(filtersData && resolveDate(filtersData.endDateString)) ||
                        '-'}
                  </div>
               </div>
               <div className={classes.graphsContainer}>
                  {MultiChartData && (
                     <div>
                        <div class='sub-title'>
                           {MultiChartData[0].graphName}
                        </div>
                        <ReactECharts
                           option={mapOptions(MultiChartData[0])}
                           style={{ height: 300, width: '100%' }}
                        />
                     </div>
                  )}
                  {MultiChartData && (
                     <div>
                        <div class='sub-title'>
                           {MultiChartData[1].graphName}
                        </div>
                        <ReactECharts
                           option={mapOptions(MultiChartData[1])}
                           style={{ height: 300, width: '100%' }}
                        />
                     </div>
                  )}
               </div>
            </div>
         </div>
         <div className='page' id='2'>
            <div className='subpage'>
               <div className={classes.graphsContainer}>
                  {MultiChartData && (
                     <div>
                        <div class='sub-title'>
                           {MultiChartData[2].graphName}
                        </div>
                        <ReactECharts
                           option={mapOptions(MultiChartData[2])}
                           style={{ height: 300, width: '100%' }}
                        />
                     </div>
                  )}
                  {MultiChartData && (
                     <div>
                        <div class='sub-title'>
                           {MultiChartData[3].graphName}
                        </div>
                        <ReactECharts
                           option={mapOptions(MultiChartData[3])}
                           style={{ height: 300, width: '100%' }}
                        />
                     </div>
                  )}
               </div>
            </div>
         </div>
         <div className='page' id='2'>
            <div className='subpage'>
               <div>
                  {MultiTable && (
                     <div>
                        <div className='title'>{MultiTable[0].listName}</div>
                        <table className='normal'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>รหัสพนักงาน</th>
                              <th>ชื่อพนักงาน</th>
                              <th>ชื่อสังกัด</th>
                              <th>ตำแหน่ง</th>
                              <th>จำนวนครั้ง</th>
                              <th>P ที่ใช้</th>
                              <th>P ที่ได้รับ</th>
                           </tr>
                           {MultiTable[0].bankWalletUsages.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.orgEmployeeId}</td>
                                 <td>{item.employeeName}</td>
                                 <td>{item.divisionName}</td>
                                 <td>{item.positionName}</td>
                                 <td class='text-right'>
                                    {item.numberofUsage}
                                 </td>
                                 <td class='text-right'>
                                    {item.totalUsagePoints}
                                 </td>
                                 <td class='text-right'>
                                    {item.totalReceivedPoints}
                                 </td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
            </div>
         </div>
         <div className='page' id='3'>
            <div className='subpage'>
               <div>
                  {MultiTable && (
                     <div>
                        <div className='title'>{MultiTable[1].listName}</div>
                        <table className='normal'>
                           <tr>
                              <th>ลำดับ</th>
                              <th>รหัสพนักงาน</th>
                              <th>ชื่อพนักงาน</th>
                              <th>ชื่อสังกัด</th>
                              <th>ตำแหน่ง</th>
                              <th>จำนวนครั้ง</th>
                              <th>P ที่ใช้</th>
                              <th>P ที่ได้รับ</th>
                           </tr>
                           {MultiTable[1].bankWalletUsages.map((item) => (
                              <tr>
                                 <td>{item.seq}</td>
                                 <td>{item.orgEmployeeId}</td>
                                 <td>{item.employeeName}</td>
                                 <td>{item.divisionName}</td>
                                 <td>{item.positionName}</td>
                                 <td class='text-right'>
                                    {item.numberofUsage}
                                 </td>
                                 <td class='text-right'>
                                    {item.totalUsagePoints}
                                 </td>
                                 <td class='text-right'>
                                    {item.totalReceivedPoints}
                                 </td>
                              </tr>
                           ))}
                        </table>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

export default PDFCSS;
